/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useRef, useState} from 'react';
import useToggle from "../../../hook/ToggleHook";
import {useTranslation} from "react-i18next";


const SelectInputComponent = ({label, field_name, listData, input, setInput, useLocale, empty_text, onChange, disabled, useSearch=false, add_scroll=false, show_note=false, note_message=null, auto_width=true}) => {
    const [open, node, context] = useToggle();
    const [t, i18n] = useTranslation();
    const [onSearchInput, setOnSearchInput] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [message, setMessage] = useState('');

    const onSelected = (value) => {
        setInput((prevInput) => {
            prevInput[field_name] = {
                value: value,
                error: null,
                required: prevInput[field_name].required
            }
            return {...prevInput}
        });
        if (onChange && onChange instanceof Function) {
            onChange(value);
        }
        setOnSearchInput(false);
    };

    return (
        <div className="form-row">
            {label && <div className={`form-label ${input[field_name]?.required ? 'required' : ''}`}><label>{label}</label></div>}
            <div className="form-field">
                <div className={`comp-select ${auto_width ? 'auto-width comp-select--small drop-adjustable' : ''} ${open === 'show' ? 'active' : ''}`}>
                    <div className="select-toggle" ref={node}>
                        <span className={`select-label ${disabled ? 'color-gray-light' : ''}`}>
                            {input?.[field_name]?.value && useLocale ? t(`@${input[field_name]?.value}@`) : input[field_name].value || empty_text}
                            <input name={field_name} type="text" value={input[field_name].value} className='hide' onChange={()=>{}}/>
                        </span>
                    </div>
                    <div
                        className={`comp-dropdown comp-select-dropdown ${(open === 'show' || onSearchInput) && !disabled ? '' : 'hide'}`}>
                        <ul className={`comp-dropdown-menu !max-w-40vw ${add_scroll ? 'add-scroll' : ''} overlay-scroll`}>
                            {useSearch &&
                                <li className="section func-section contacts-filter">
                                    <div className="filter-bar">
                                        <input type="text" placeholder={t('@Search@')}
                                               onFocus={e => setOnSearchInput(true)}
                                               onChange={e => {
                                                   setSearchQuery(e.target.value);
                                               }}
                                        />
                                    </div>
                                </li>
                            }

                            <li className="section add-scroll">
                                {listData.filter(c=>t(`@${c}@`).match(new RegExp(searchQuery, 'i'))).map((item, index) => {
                                        return <div className="section-items selection"
                                                    key={index}
                                                    onClick={() => onSelected(item)}>{useLocale ? t(`@${item}@`) : item}</div>
                                    }
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
                {
                    show_note && note_message && <div className="note-msg">{
                        note_message && typeof note_message === 'string' ? t(note_message) : t(note_message.get(input[field_name]?.value))
                    }</div>
                }
            </div>
        </div>
    );
};

export default SelectInputComponent;